import {Box} from '@mui/material';
import {FC} from 'react';
import {barSx, spacerSx} from './RecordActionBar.sx';
import {RecordActionBarProps} from './RecordActionBar.types';

/**
 * The record page's actions, pinned within thumb reach.
 *
 * On a phone the primary action used to scroll away with the content it acts on - on a contract it
 * sat above a portrait PDF, so "archive" was three screens down. The bar holds whatever the page
 * already offered, in the page's own order, and reserves its own height so the last card is never
 * trapped underneath it.
 */
export const RecordActionBar: FC<RecordActionBarProps> = ({children, reserveSpace = true}) => (
    <>
        {reserveSpace && (
            <Box
                sx={spacerSx}
                aria-hidden
            />
        )}
        <Box sx={barSx}>{children}</Box>
    </>
);
